export default "__VITE_ASSET__zYVvsq$B__"